var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col min-h-screen",attrs:{"id":"app"}},[(_vm.sessionInitialized && _vm.canRenderCurrentRoute)?[_c('Header'),_c('router-view')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }